import { trackUserFacingError } from "@/infrastructure/analytics";
import { useToastStore } from "@/stores/useToastStore";

/**
 * Bridges the toast store to analytics: every newly-shown error/warning toast
 * is reported via trackUserFacingError. Kept out of the store itself so the
 * store stays a pure state container (no infrastructure imports).
 */
export function initToastAnalytics() {
  let seenIds = new Set<string>(useToastStore.getState().toasts.map((t) => t.id));

  useToastStore.subscribe((state) => {
    const currentIds = new Set<string>();
    for (const toast of state.toasts) {
      currentIds.add(toast.id);
      if (seenIds.has(toast.id)) continue;
      if (toast.type === "error" || toast.type === "warning") {
        trackUserFacingError({
          message: toast.message,
          title: toast.title,
          type: toast.type,
        });
      }
    }
    seenIds = currentIds;
  });
}
